import './processes.css';
import * as React from 'react';
import {Component} from "react";
import {ProcessSingle} from "../../widgets";
import {setActiveMenuItem, setLogoWhite, setNavbarTheme} from "../../util";



export class ProcessTwo extends Component {

    componentDidMount() {
        setNavbarTheme('#040f2b');
        setActiveMenuItem('prosess', window.innerWidth < 1000);
        setLogoWhite(false);
    }

    render() {
        return (
            <div className={'process-two'}>
                <ProcessSingle header={'2. Analyse'} text={'Lorem Ipsum'} image={'resources/blonomAnalysis.jpg'}/>
            </div>
        );
    }
}